import { z } from 'zod'

export const HomepageWidgetTypeEnum = z.enum([
  'buildingImage',
  'shortcuts',
  'upcomingEvents',
  'announcements',
  'buildingEssentials',
  'services',
  'residentTasks',
  'chat',
  'amenities',
  'neighborhoodPerks',
  'transport',
])
export type HomepageWidgetType = z.infer<typeof HomepageWidgetTypeEnum>

export const ShortcutTypeEnum = z.enum([
  'payRent',
  'maintenanceRequests',
  'bookings',
  'unlockDoor',
  'packages',
  'callUs',
  'emailUs',
  'parking',
  'visitors',
  'essentials',
])
export type ShortcutType = z.infer<typeof ShortcutTypeEnum>

export type HomepagePosition = {
  position: number
  widget: HomepageWidgetType
}

export type HomepageShortcut = {
  type: ShortcutType
  position: number
}

export type HomepageService = {
  bookingType: number
  position: number
  data?: { name: string }
}

// buildingEssentials / amenities / neighborhoodPerks aren't editable on this page (their items
// are managed elsewhere) - kept as opaque pass-through entries so save payloads round-trip.
export type HomepagePositionedEntry = Record<string, unknown> & { position: number }

export type HomepageConfigResponse = {
  buildingId: number
  buildingImageEnabled: boolean
  buildingImageFile: string | null
  buildingImageFadeEnabled: boolean
  shortcutsEnabled: boolean
  shortcuts: HomepageShortcut[]
  upcomingEventsEnabled: boolean
  announcementsEnabled: boolean
  residentTasksEnabled: boolean
  buildingEssentialsEnabled: boolean
  buildingEssentials: HomepagePositionedEntry[]
  servicesEnabled: boolean
  services: HomepageService[]
  chatEnabled: boolean
  amenitiesEnabled: boolean
  amenities: HomepagePositionedEntry[]
  neighborhoodPerksEnabled: boolean
  neighborhoodPerks: HomepagePositionedEntry[]
  transportEnabled: boolean
  positions: HomepagePosition[]
}
